import * as React from 'react';
import {Link} from 'react-router-dom';
import {
    Card,
    CardContent,
    CardHeader, Divider,
    IconButton,
    Popover as PopoverUI, List, ListItem, ListItemText, ListItemButton, Avatar
} from "@mui/material";
import {useSelector} from "react-redux";
import CloseIcon from "@mui/icons-material/Close";
import {styled} from "@mui/material/styles";
import ListItemIcon from "@mui/material/ListItemIcon";
import PermIdentityIcon from '@mui/icons-material/PermIdentity';
import LogoutIcon from '@mui/icons-material/Logout';
import LanguageIcon from '@mui/icons-material/Language';
import ContrastIcon from '@mui/icons-material/Contrast';

const Popover = styled(PopoverUI)(({ theme }) => ({
    '& .MuiPaper-root':{
        boxShadow: '0px 0px 6px 0px rgba(0,0,0,0.2)',
        [theme.breakpoints.down('md')]: {
            minWidth: '100%', // Minimum width for desktop view
            minHeight:'100%',
            left:'0!important',
            top:'0!important',
            height:'100%',
        },
    }
}));

const PopoverCard = styled(Card)(({ theme }) => ({
    width: '100%',
    minWidth: 300,
    display: 'flex',
    flexDirection: 'column',
    '& .MuiCardContent-root':{
        flex: '1',
        overflowY:'auto',
        [theme.breakpoints.down('sm')]: {
            maxHeight: 'inherit',
        },
        '& .MuiListItemButton-root':{
            '& .MuiListItemIcon-root':{
                color: theme.palette.secondary,
                minWidth: '2rem',

                // 👇 target inner svg directly
                '& svg': {
                    fontSize: '1.2rem', // 👈 this controls actual icon size
                },
            },
        }
    },
    [theme.breakpoints.down('md')]: {
        minWidth: 300,
    },
}));


export const AccountMenu = () => {

    const auth = useSelector((store)=> store.auth);

    const [anchorEl, setAnchorEl] = React.useState(null);
    const open = Boolean(anchorEl);
    const id = open ? 'simple-popover' : undefined;

    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    return (
        <>
            <IconButton onClick={handleClick}>
                <Avatar src={auth.user?.avatar_url || '/images/user-icon-3.jpg'} sx={{width: '2rem', height: '2rem', backgroundColor: 'accent.dark'}}>
                    {auth.user?.first_name?.charAt(0)}
                </Avatar>
            </IconButton>
            <Popover
                id={id}
                open={open}
                anchorEl={anchorEl}
                onClose={handleClose}
                anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'right',
                }}
                transformOrigin={{
                    vertical: 'top',
                    horizontal: 'right',
                }}
            >
                <PopoverCard>
                    <CardHeader
                        avatar={
                            <Avatar src={auth?.user?.avatar_url || '/images/user-icon-3.jpg'} sx={{width: '3rem', height: '3rem'}}>
                                {auth.user?.first_name?.charAt(0)}
                            </Avatar>
                        }
                        title={auth?.user?.first_name + ' ' + auth?.user?.last_name}
                        subheader={"" + auth.user?.email}
                        titleTypographyProps={{fontWeight:'bold', fontSize:'1rem'}}
                        action={
                            <IconButton
                                edge="end"
                                color="inherit"
                                onClick={handleClose}
                                aria-label="close"
                                size={'small'}
                                sx={{
                                    display: {
                                        xs: 'block', // visible on xs
                                        sm: 'none',  // hidden on sm and above
                                    },
                                    position: 'absolute', top: '8px', right: '15px'
                                }}
                            >
                                <CloseIcon fontSize={'0.5rem'} />
                            </IconButton>
                        }>
                    </CardHeader>
                    <CardContent sx={{p:'0!important'}}>
                        <List>
                            <ListItem disablePadding>
                                <ListItemButton component={Link} to={`/users/${auth.user?.id}`}>
                                    <ListItemIcon>
                                        <PermIdentityIcon />
                                    </ListItemIcon>
                                    <ListItemText primary="Profile" />
                                </ListItemButton>
                            </ListItem>
                            { 1 === 2 && (
                                <ListItem disablePadding>
                                    <ListItemButton component={Link} to={'/dark-theme'}>
                                        <ListItemIcon>
                                            <ContrastIcon/>
                                        </ListItemIcon>
                                        <ListItemText primary="Dark Theme"/>
                                    </ListItemButton>
                                </ListItem>
                            )}
                            { 1 === 2 && (
                                <ListItem disablePadding>
                                    <ListItemButton component={Link} to={'/language'}>
                                        <ListItemIcon>
                                            <LanguageIcon />
                                        </ListItemIcon>
                                        <ListItemText primary="Language" />
                                    </ListItemButton>
                                </ListItem>
                            )}
                            <Divider />
                            <ListItem disablePadding>
                                <ListItemButton component={Link} to={'/logout'}>
                                    <ListItemIcon>
                                        <LogoutIcon />
                                    </ListItemIcon>
                                    <ListItemText primary="Logout" />
                                </ListItemButton>
                            </ListItem>
                        </List>
                    </CardContent>
                </PopoverCard>
            </Popover>
        </>
    );
}
